import type { Summer2026SaleVariant } from '../constants/summer-2026-sale';

/**
 * CONENG-2451 sitewide sale variants map to Sanity `promotionId` values (geo-targeted in CMS).
 * Gate on `promotionId` — never on `promoCode`, which is the mutable Braavos coupon at checkout.
 *
 * Market tiers: `SUMMER26US` and `SUMMER26G1` are full_price_market; `SUMMER26G2` is new_price_market.
 */
export const SUMMER_2026_JULY_4TH_PROMOTION_ID = 'SUMMER26US';
export const SUMMER_2026_SUMMER_PROMOTION_ID = 'SUMMER26G1';
export const SUMMER_2026_MID_YEAR_SALE_PROMOTION_ID = 'SUMMER26G2';

export type Summer2026SaleMarketTier = 'full' | 'low';

export function getSummer2026SaleMarketTier(variant: Summer2026SaleVariant): Summer2026SaleMarketTier {
  return variant === 'mid_year_sale' ? 'low' : 'full';
}

export function getSummer2026SaleVariant(promotionId: string | null | undefined): Summer2026SaleVariant | null {
  if (promotionId === SUMMER_2026_JULY_4TH_PROMOTION_ID) {
    return 'july_4th';
  }
  if (promotionId === SUMMER_2026_SUMMER_PROMOTION_ID) {
    return 'summer';
  }
  if (promotionId === SUMMER_2026_MID_YEAR_SALE_PROMOTION_ID) {
    return 'mid_year_sale';
  }
  return null;
}

export function getSummer2026SaleSlideKey(variant: Summer2026SaleVariant): string {
  return `summer-2026-sale-${variant}`;
}

/** `?force_promo=<promotionId>` wins over the live `usePromotion` response (preview QA only). */
export function resolveSummer2026SaleVariant(
  forcedPromotionId: string | null | undefined,
  promotionId: string | null | undefined
): Summer2026SaleVariant | null {
  return getSummer2026SaleVariant(forcedPromotionId) ?? getSummer2026SaleVariant(promotionId);
}
